function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Ellipse, Path } from 'react-native-svg';
export function Settings({
  width = 36,
  height = 33,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M31.21 10.374l-.934-1.443c-.79-1.221-2.54-1.642-3.913-.942v0a3.163 3.163 0 01-2.167.27c-.734-.169-1.362-.592-1.746-1.175a2.25 2.25 0 01-.384-1.222v0c.022-.69-.27-1.36-.81-1.855-.541-.496-1.284-.775-2.06-.775h-1.88c-.76 0-1.489.27-2.025.75-.536.48-.835 1.13-.832 1.806v0c-.022 1.397-1.3 2.52-2.869 2.52a3.004 3.004 0 01-1.373-.343v0c-1.373-.7-3.123-.28-3.913.942l-1.002 1.467c-.79 1.22-.323 2.777 1.043 3.485v0c.888.457 1.435 1.3 1.435 2.214 0 .913-.547 1.756-1.435 2.213v0c-1.364.703-1.831 2.257-1.043 3.473v0l.947 1.455c.37.595.991 1.034 1.725 1.22a3.183 3.183 0 002.188-.23v0a3.149 3.149 0 012.167-.258c.732.174 1.356.602 1.732 1.188.247.37.38.792.385 1.223v0c0 1.411 1.285 2.556 2.87 2.556h1.88c1.58 0 2.862-1.137 2.87-2.544v0c-.004-.679.297-1.33.836-1.81a3.044 3.044 0 012.034-.746 3.2 3.2 0 011.372.343v0c1.37.702 3.119.287 3.914-.93v0l.988-1.467a2.302 2.302 0 00.292-1.936c-.196-.654-.676-1.212-1.335-1.55v0c-.66-.337-1.14-.895-1.336-1.549a2.303 2.303 0 01.292-1.935 2.682 2.682 0 011.044-.93v0c1.357-.707 1.823-2.256 1.043-3.473v0-.012z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Ellipse, {
    cx: 18.263,
    cy: 16.073,
    rx: 3.954,
    ry: 3.522,
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
//# sourceMappingURL=Settings.js.map